export enum SegmentationType {
  RESIZE = 'resize',
  AV = 'av',
  DISC = 'disc',
  A = 'a',
  AVR = 'avr',
  CROSSING = 'crossing',
  GRID = 'grid', // 4 images in a 2x2 grid
}
